import styled from 'styled-components';

export const EditButton = styled.button`
  width: 38px;
  cursor: pointer;
  border-left: thin solid #d1d1d1;
  border-right: thin solid #d1d1d1;
  border-top: thin solid rgba(209, 209, 209, 0.7);
  border-bottom: thin solid rgba(209, 209, 209, 0.7);
  margin: 0;
  background: #fff;
  height: 36px;
  text-decoration: none;
  outline: 0;
  padding-top: 2px;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    -ms-grid-column: ${({ ie11GridColumn }) => ie11GridColumn};
  }
`;
